<template>
  <div v-if="$parent.ownProfile">
    <div class="quizz" v-if="!$store.state.loading && !quizz">
      <h3>Qu'est ce que mon Quizz Personnel ?</h3>
      <ul>
        <li>
          Mon Quizz Personnel est un ensemble de 5 questions au minimum et jusqu'à 20 questions. C'est un test de
          personnalité.
        </li>
        <li>
          Je choisis mes questions parmi une liste proposée par Idylive et j'indique ma réponse (oui ou non)
        </li>
        <li>
          Les autres membres pourront alors répondre à mon Quizz et je pourrai voir si leur réponses correspondent aux
          miennes et savoir si nos personnalités correspondent !
        </li>
      </ul>
      <img id="exempleQuizz" src="/assets/images/quizz_exemple.jpg" />

      <a href="#" class="bouton" @click.prevent="createQuizz">
        Créer mon Quizz
      </a>
    </div>

    <div class="quizz" v-if="quizz">
      <template v-if="quizz.questions.length < 20">
        <ul class="ajout">
          <li>
            Pour ajouter une question à mon Quizz, je répond à la question en cliquant sur Oui ou Non.
          </li>
          <li>
            Si la question ne me plaît pas, je clique sur "Passer", de nouvelles questions seront proposées.
          </li>
          <li>
            Mon Quizz sera publié automatiquement lorsqu'il comprendra au moins 5 questions.
          </li>
        </ul>

        <QuizzQuestion
          v-if="currentQuestion"
          :question="currentQuestion"
          @yes="addQuestion(true)"
          @no="addQuestion(false)"
          @next="nextQuestion()"
        />
      </template>
      <template v-else>
        <p class="fel">
          <b>Félicitations !</b> Votre quizz est complet, les membres d'Idylive qui consultent votre profil pourront y
          répondre, vous recevrez leur réponse dans votre messagerie.
        </p>
      </template>
      <div class="monQuizz" v-if="quizz.questions && quizz.questions.length">
        <h3>{{ quizz.questions.length }} Question{{ s }}{{ incomplet }}</h3>
        <div class="answers">
          <QuizzAnsweredQuestion
            @delete="deleteQuestion"
            v-for="(answer, index) in quizz.questions"
            :index="index"
            :answer="answer"
            :key="answer.id"
          />
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div v-if="hasQuizz" class="otherQuizz">
      <div if="this.questions">
        <div class="answeredQuestion">
          <span v-if="this.quizzResults.length < this.questions.length">
            Question {{ this.quizzResults.length + 1 }} sur {{ this.questions.length }}
          </span>
          <span v-else></span>
          <span>{{ $parent.MLE }}</span>
          <span>Moi</span>
        </div>
        <QuizzResult v-for="result in quizzResults" :key="result.id" :result="result" />
      </div>
      <QuizzQuestion
        v-if="!quizzComplete && currentQuestion"
        :question="currentQuestion"
        @yes="answerQuestion(true)"
        @no="answerQuestion(false)"
        @next="answerQuestion(null)"
      />
      <div class="commun" v-if="quizzComplete">{{ commun }} réponses en commun.</div>
    </div>
  </div>
</template>

<script>
import QuizzQuestion from "@/components/profile/QuizzQuestion";
import QuizzAnsweredQuestion from "@/components/profile/QuizzAnsweredQuestion";
import QuizzResult from "@/components/profile/QuizzResult";
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";
import Vue from "vue";

export default {
  name: "Quizz",
  components: { QuizzQuestion, QuizzAnsweredQuestion, QuizzResult },
  props: ["profile"],
  data() {
    return {
      quizz: null,
      currentIndex: 0,
      questions: null,
      quizzResults: [],
      quizzComplete: false
    };
  },

  methods: {
    async init() {
      await Vue.nextTick();
      this.quizzComplete = false;
      this.currentIndex = 0;
      this.quizzResults = [];
      this.quizz = null;
      this.quizz = await idyuJsonRpc("getQuizz", this.profile.id);
      if (this.$parent.ownProfile) {
        this.questions = await idyuJsonRpc("getAllQuestions");
      } else {
        if (this.quizz) this.questions = this.quizz.questions;
      }

      if (!this.$parent.ownProfile && this.hasQuizz) {
        let res = await idyuJsonRpc("getLastestQuizzResults", this.profile.id);
        if (res) {
          this.quizzComplete = true;
          this.quizzResults = res.results;
        }
      }
      return this.$parent.ownProfile || this.hasQuizz;
    },

    async createQuizz() {
      this.quizz = await idyuJsonRpc("createQuizz");
    },

    async addQuestion(val) {
      let answerId = await idyuJsonRpc("addQuizzQuestion", this.currentQuestion.id, val);
      if (answerId == 0) {
        return;
      }
      this.quizz.questions.push({
        id: answerId,
        question: this.currentQuestion,
        answer: val
      });
      await this.nextQuestion();
    },

    async deleteQuestion(index) {
      if (await confirm("Voulez-vous vraiment retirer cette question de votre quizz ?")) {
        await idyuJsonRpc("removeQuizzQuestion", this.quizz.questions[index].id);
        this.quizz.questions.splice(index, 1);
      }
    },

    async nextQuestion() {
      if (this.currentIndex < this.questions.length) {
        this.currentIndex++;
      } else {
        await idyuJsonRpc("getAllQuestions");
        this.currentIndex = 0;
      }

      while (this.quizz.questions.find(elt => this.questions[this.currentIndex].id == elt.idQuestion)) {
        this.currentIndex++;
      }
    },

    async answerQuestion(val) {
      this.quizzResults.push({
        className: "quizz.CResult",
        answerUser: val,
        answerQuizz: this.currentQuestion.answer,
        question: this.currentQuestion.question,
        order: this.quizzResults.length + 1
      });

      if (this.currentIndex < this.questions.length) {
        this.currentIndex++;
        await Vue.nextTick();
        window.scrollTo(0, document.body.scrollHeight);
      }
      if (this.currentIndex === this.questions.length) {
        await idyuJsonRpc("saveQuizzResults", this.quizzResults, this.$parent.profile.id);
      }
    }
  },

  created: function() {
    this.init();
  },

  computed: {
    currentQuestion() {
      if (!this.questions) return null;
      return this.questions[this.currentIndex];
    },

    s() {
      if (!this.quizz || !this.quizz.questions || this.quizz.questions.length <= 1) return "";
      return "s";
    },

    hasQuizz() {
      return this.quizz && this.quizz.questions && this.quizz.questions.length >= 10;
    },

    commun() {
      let res = 0;
      for (let result of this.quizzResults) {
        if (result.answerQuizz == result.answerQuizz) res++;
      }
      return res;
    },

    incomplet() {
      if (this.quizz.questions.length < 5) return " (Quizz incomplet)";
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";
@import "@/assets/css/quizz.scss";
h3 {
  margin-top: 0;
  margin-bottom: 0;
}

#exempleQuizz {
  margin-bottom: 10px;
  max-width: 100%;
}

.quizz {
  display: grid;
  font-size: 16px;
  padding-bottom: 10px;
}

.monQuizz {
  margin-top: 10px;
  h3 {
    margin-bottom: 5px;
  }
}

.otherQuizz {
  padding-bottom: 10px;
}

.answers {
  display: grid;
}

.commun {
  margin-top: 10px;
}

.fel {
  font-size: 20px;
}
</style>
